import classnames from 'classnames';
import config from 'config';
import { bool, func, object, oneOf } from 'prop-types';
import { Component } from 'react';

import Button from 'shared/components/button/Button';
import Checkmark from 'shared/components/icon/Checkmark';
import Download from 'shared/components/icon/Download';
import Duplicate from 'shared/components/icon/Duplicate';
import Edit from 'shared/components/icon/Edit';
import Open from 'shared/components/icon/Open';
import Trash from 'shared/components/icon/Trash';
import { getText } from 'shared/utils/Text';

const downloadUrl = `${config.jokerApi}/archive/downloadBet/`;

export default class ArchiveItem extends Component {
  static propTypes = {
    editHandler: func,
    openHandler: func,
    duplicateHandler: func,
    deleteHandler: func.isRequired,
    item: object.isRequired,
    type: oneOf(['bet', 'template']).isRequired,
    isCurrent: bool.isRequired,
    isSelectedForDelection: bool.isRequired,
    downloadEnabled: bool,
  };

  onOpen = () => {
    const { isCurrent, openHandler, item } = this.props;
    if (!isCurrent) {
      openHandler(item);
    }
  };

  onEdit = () => {
    const { editHandler, item } = this.props;
    editHandler(item);
  };

  onDuplicate = () => {
    const { duplicateHandler, item } = this.props;
    duplicateHandler(item);
  };

  onDelete = () => {
    const { isCurrent, deleteHandler, item } = this.props;
    if (!isCurrent) {
      deleteHandler(item);
    }
  };

  render() {
    const {
      item,
      type,
      renderItemBox,
      renderItemInfo,
      isCurrent,
      isSelectedForDelection,
      downloadEnabled,
      editHandler,
      openHandler,
      duplicateHandler,
    } = this.props;

    const className = classnames(
      `fgrid fgrid--center fgrid--justifyCenter fgrid--archive-item fgrid--archive-item--${type}`,
      {
        'delete-selected': isSelectedForDelection,
      },
    );

    // TODO - In the future try standardise these items between ATG and Sport...
    let isOwned;
    if (typeof item.isOwned === 'function') {
      // ATG (SavedBet class) will look like this
      isOwned = item.isOwned();
    } else if (typeof item.owned === 'boolean') {
      // Sport will look like this
      isOwned = item.owned;
    }

    return (
      <div>
        <hr />
        <div className={className}>
          {renderItemBox?.(item)}
          <div className="fgrid-cell fgrid-cell-info">
            {renderItemInfo(item)}
          </div>

          {editHandler && (
            <div className="fgrid-cell fgrid-cell-button">
              <Button className="item-button" onClick={this.onEdit}>
                <div className="item-button__inner">
                  <div className="item-button__icon">
                    <Edit />
                  </div>
                  <div className="item-button__label">
                    {getText('dialog-archive-edit')}
                  </div>
                </div>
              </Button>
            </div>
          )}

          {openHandler && (
            <div className="fgrid-cell fgrid-cell-button">
              <Button
                className="item-button"
                onClick={this.onOpen}
                disabled={isCurrent}
              >
                <div className="item-button__inner">
                  <div className="item-button__icon">
                    <Open />
                  </div>
                  <div className="item-button__label">
                    {getText('dialog-archive-open')}
                  </div>
                </div>
              </Button>
            </div>
          )}

          {duplicateHandler && (
            <div className="fgrid-cell fgrid-cell-button">
              <Button className="item-button" onClick={this.onDuplicate}>
                <div className="item-button__inner">
                  <div className="item-button__icon">
                    <Duplicate />
                  </div>
                  <div className="item-button__label">
                    {getText('dialog-archive-duplicate')}
                  </div>
                </div>
              </Button>
            </div>
          )}

          {downloadEnabled && item.data !== undefined && (
            <div className="fgrid-cell fgrid-cell-button">
              <a
                className="item-button item-button__label"
                href={downloadUrl + item.data.id}
              >
                <div className="item-button__inner">
                  <div className="item-button__icon">
                    <Download />
                  </div>
                  <div className="item-button__label">
                    {getText('dialog-archive-download')}
                  </div>
                </div>
              </a>
            </div>
          )}

          <div className="fgrid-cell fgrid-cell-button delete-cell">
            <Button
              className="item-button"
              onClick={this.onDelete}
              disabled={type === 'bet' && (isCurrent || !isOwned)}
            >
              <div className="item-button__inner">
                <div className="item-button__icon">
                  {isSelectedForDelection && <Checkmark />}
                  {!isSelectedForDelection && <Trash />}
                </div>
                <div className="item-button__label">
                  {getText('dialog-archive-delete')}
                </div>
              </div>
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
